import { isNotNullish } from './type-utils';

export function removeNullishValues(obj: Record<string, unknown>): Record<string, unknown> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => isNotNullish(value)));
}
